import KunLoading116 from './src/index'

KunLoading116.install = function (Vue) {
	Vue.component(KunLoading116.name, KunLoading116);
}

export default KunLoading116;
